<template>
    <div class="md-layout" v-if="screenVisible">
        <md-toolbar
            md-elevation="1"
            style="position: sticky"
            v-if="selectedHistoryFilterFields.product"
        >
            <h3 class="md-title" style="flex: 1">
                Gostaria de parametrizar as filiais para esse produto?
            </h3>
            <md-button
                class="md-primary mr-1"
                @click="
                    $router.push(
                        '/branch-params/' + selectedHistoryFilterFields.product
                    )
                "
            >
                Gerenciar filiais
            </md-button>
            <md-button
                class="md-primary"
                @click="
                    $router.push(
                        '/dc-params-simulation/' +
                            selectedHistoryFilterFields.product
                    )
                "
            >
                Gerenciar CDs
            </md-button>
        </md-toolbar>

        <!-- Novo Filtro -->
        <div class="md-layout-item md-size-100">
            <md-card class="pl-1 pr-1 bt-blue500 hidden-card">
                <maximize-and-minimize></maximize-and-minimize>
                <md-card-header class="pb-0">
                    <h4 class="title pt-1">Pesquisar</h4>
                </md-card-header>
                <md-card-content class="pt-2 pb-2">
                    <div class="md-layout">
                        <div class="md-layout-item md-size-100 mb-2">
                            <md-field>
                                <label for="history">Histórico</label>
                                <md-menu
                                    class="md-layout md-size-50"
                                    md-align-trigger
                                    md-size="big"
                                    :mdCloseOnClick="false"
                                    :mdCloseOnSelect="true"
                                >
                                    <md-input
                                        md-menu-trigger
                                        v-model="selectedHistoryFilterName"
                                        style="cursor: pointer;"
                                        readonly
                                    ></md-input>
                                    <md-icon>keyboard_arrow_down</md-icon>

                                    <md-menu-content
                                        class="md-layout-item md-size-80"
                                        style="background: #FFF"
                                    >
                                        <div
                                            style="text-decoration: underline;"
                                            class="mb-1"
                                        >
                                            <b>Favoritos</b>
                                        </div>
                                        <div
                                            class="md-layout"
                                            v-for="(filter, idx) in filterLiked"
                                            v-bind:key="
                                                `filter-favorite--${idx}`
                                            "
                                        >
                                            <div class="">
                                                <button
                                                    class="btn-star"
                                                    @click="unlike(filter.id)"
                                                >
                                                    <i
                                                        class="fas fa-star"
                                                        style="color: #000; -webkit-text-stroke-width: 1px; -webkit-text-stroke-color: #000;"
                                                    ></i>
                                                </button>
                                            </div>
                                            <div
                                                class="md-layout-item md-size-50"
                                            >
                                                <md-menu-item
                                                    class=""
                                                    @click="
                                                        selectHistoryFilter(
                                                            filter
                                                        )
                                                    "
                                                >
                                                    {{ filter.name }}
                                                </md-menu-item>
                                            </div>
                                        </div>
                                        <div
                                            style="text-decoration: underline;"
                                            class="mb-1"
                                        >
                                            <b>Recentes</b>
                                        </div>
                                        <div
                                            class="md-layout"
                                            v-for="(filter,
                                            idx) in filterUnLiked"
                                            v-bind:key="
                                                `filter-recente--${idx}`
                                            "
                                        >
                                            <div class="" v-if="filter.id">
                                                <button
                                                    class="btn-star"
                                                    @click="like(filter.id)"
                                                >
                                                    <i
                                                        class="fas fa-star"
                                                        style="color: #FFF; -webkit-text-stroke-width: 1px; -webkit-text-stroke-color: #000;"
                                                    ></i>
                                                </button>
                                            </div>
                                            <div
                                                class="md-layout-item md-size-50"
                                            >
                                                <md-menu-item
                                                    class=""
                                                    @click="
                                                        selectHistoryFilter(
                                                            filter
                                                        )
                                                    "
                                                >
                                                    {{ filter.name }}
                                                </md-menu-item>
                                            </div>
                                        </div>
                                    </md-menu-content>
                                </md-menu>
                            </md-field>
                        </div>
                        <div
                            class="md-layout-item md-size-25 md-small-size-100"
                        >
                            <md-field>
                                <label for="channel">
                                    Árvore de sortimento
                                </label>
                                <md-input
                                    name="node"
                                    id="node"
                                    value=""
                                    style="cursor: pointer;"
                                    v-model="selectedHistoryFilterNodeName"
                                    @click="treeModalOpen(true)"
                                    readonly
                                >
                                </md-input>
                                <md-icon>account_tree</md-icon>
                            </md-field>
                        </div>
                        <div
                            class="md-layout-item md-size-25 md-small-size-100"
                        >
                            <md-field>
                                <label>Produto</label>
                                <vue-simple-suggest
                                    v-model="productModel"
                                    :list="productsList"
                                    :debounce="500"
                                    display-attribute="name"
                                    value-attribute="id"
                                    placeholder="Produto"
                                    @select="productSelected"
                                >
                                </vue-simple-suggest>
                            </md-field>
                        </div>
                        <div
                            class="md-layout-item md-size-25 md-small-size-100"
                        >
                            <md-field>
                                <label>Cluster</label>
                                <md-input
                                    type="text"
                                    v-model="
                                        selectedHistoryFilterFields.cluster
                                    "
                                ></md-input>
                            </md-field>
                        </div>
                        <div
                            class="md-layout-item md-size-25 md-small-size-100"
                        >
                            <md-field>
                                <label for="channel">Canal</label>
                                <md-select
                                    name="channel"
                                    id="channel"
                                    value="A"
                                    v-model="
                                        selectedHistoryFilterFields.channel
                                    "
                                >
                                    <md-option
                                        v-for="(channel, index) in channelsData"
                                        v-bind:key="`channel-${index}`"
                                        :value="channel.id"
                                    >
                                        {{ channel.name }}
                                    </md-option>
                                </md-select>
                            </md-field>
                        </div>
                        <div
                            class="md-layout-item md-size-25 md-small-size-100"
                        >
                            <md-field>
                                <label>Região</label>
                                <md-input
                                    disabled="disabled"
                                    type="text"
                                    v-model="selectedHistoryFilterFields.region"
                                ></md-input>
                            </md-field>
                        </div>
                        <div
                            class="md-layout-item md-size-25 md-small-size-100"
                        >
                            <md-field>
                                <label>Estado</label>
                                <md-input
                                    type="text"
                                    v-model="selectedHistoryFilterFields.state"
                                ></md-input>
                            </md-field>
                        </div>
                        <div
                            class="md-layout-item md-size-25 md-small-size-100"
                        >
                            <md-field>
                                <label>Cidade</label>
                                <md-input
                                    type="text"
                                    v-model="selectedHistoryFilterFields.city"
                                ></md-input>
                            </md-field>
                        </div>
                        <div
                            class="md-layout-item md-size-25 md-small-size-100"
                        >
                            <md-field>
                                <label>CD</label>
                                <md-input
                                    type="text"
                                    v-model="selectedHistoryFilterFields.dc"
                                ></md-input>
                            </md-field>
                        </div>
                        <div class="md-layout-item md-size-100 text-right mt-1">
                            <span
                                style="
                                    color: #666;
                                    padding: 10px;
                                    vertical-align: middle;
                                    line-height: 35px;
                                "
                                v-if="filterDirty"
                            >
                                As alterações não foram salvas
                            </span>

                            <md-button
                                class="md-secondary md-sm ml-1"
                                @click="applyFilter()"
                            >
                                Limpar
                            </md-button>

                            <md-button
                                class="md-primary md-sm ml-1"
                                @click="applyFilter()"
                            >
                                Pesquisar
                            </md-button>
                        </div>
                    </div>
                </md-card-content>
            </md-card>
        </div>

        <div class="md-layout-item md-size-50">
            <TasksCards type="Demand" v-bind:totalTasks="this.totalTasks" />
        </div>
        <div class="md-layout-item md-size-50">
            <TasksCards v-bind:totalTasks="this.totalTasks" />
        </div>

        <div class="md-layout-item md-size-50">
            <md-card class="p-1 topper-chart">
                <highcharts
                    :constructor-type="'chart'"
                    :options="branchScatterOptions"
                    class="chart"
                ></highcharts>
            </md-card>
        </div>
        <div class="md-layout-item md-size-50">
            <md-card class="p-1 topper-chart">
                <div id="bubble-container"></div>
            </md-card>
        </div>
        <div class="md-layout-item md-size-50">
            <md-card class="p-1 topper-chart">
                <highcharts
                    :constructor-type="'chart'"
                    :options="coverageBarsOptions"
                    class="chart"
                ></highcharts>
            </md-card>
        </div>
        <div class="md-layout-item md-size-50">
            <md-card class="p-1 topper-chart">
                <highcharts
                    :constructor-type="'chart'"
                    :options="supplierScatterOptions"
                    class="chart"
                ></highcharts>
            </md-card>
        </div>

        <!-- Modal to ask filter name when saving -->
        <modal v-if="filterModal" @close="filterModalOpen(false)">
            <template slot="header">
                <h4 class="modal-title">Salvar filtro</h4>
                <md-button
                    class="md-simple md-just-icon md-round modal-default-button"
                    @click="filterModalOpen(false)"
                >
                    <md-icon>clear</md-icon>
                </md-button>
            </template>

            <template slot="body">
                <div class="md-layout">
                    <div class="md-layout-item md-small-size-100 md-size-100">
                        <md-field>
                            <label>Nome do filtro</label>
                            <md-input v-model="filter.name"></md-input>
                        </md-field>
                    </div>
                </div>
            </template>

            <template slot="footer">
                <md-button class="md-simple" @click="filterModalOpen(false)">
                    Cancelar
                </md-button>
                <md-button
                    class="md-primary"
                    @click="filterModalSubmit()"
                    :disabled="!filter.name"
                >
                    Salvar
                </md-button>
            </template>
        </modal>

        <!-- Modal to select tree node -->
        <modal v-if="treeModal" @close="treeModalOpen(false)" width="500px">
            <template slot="header">
                <h4 class="modal-title">
                    Item da árvore de sortimento
                </h4>
                <md-button
                    class="md-simple md-just-icon md-round modal-default-button"
                    @click="treeModalOpen(false)"
                >
                    <md-icon>clear</md-icon>
                </md-button>
            </template>

            <template slot="body">
                <v-draggable-treeview
                    v-model="treeData"
                    :editable="false"
                    :openCallback="readTreeChild"
                    :clickCallback="selectTreeChild"
                ></v-draggable-treeview>
            </template>

            <template slot="footer"> </template>
        </modal>
    </div>
    <div v-else>
        <div v-if="me">
            Você não pode acessar essa página!
        </div>
    </div>
</template>

<script>
import TasksCards from '@/components/Cards/TasksCards'
import Vue from 'vue'
import { mapState, mapActions } from 'vuex'
import Swal from 'sweetalert2'
//import { ChartCard } from '@/components'
import { Pagination, Modal, VuetifyDraggableTreeview } from '@/components'
import VueSimpleSuggest from 'vue-simple-suggest'
import { ProductService } from '@/services/product.service'
import Utils from '@/utils'
import Filter from '@/models/restockingfilter.model'
import Node from '@/models/node.model'
const model = 'restocking'
import MaximizeAndMinimize from '@/components/Maximize/MaximizeAndMinimize.vue'
export default {
    async created() {
        this.getMe()
        //this.readTreeNodes()
        this.readBranchNameIds()
        this.readBranchChannels()
        this.readPlaces() // read states
        // read filters & select the last one
        await this.readFilters()

        await this.readTotalTasks()

        let selectedFilter = this.filters.reduce((last, current) =>
            new Date(last.datetime_last_seen).getTime() <
            new Date(current.datetime_last_seen).getTime()
                ? current
                : last
        )
        // create an empty filter if none has returned
        if (!selectedFilter) selectedFilter = new Filter()

        await this.selectHistoryFilter(selectedFilter)

        await this.applyFilter()

        Highcharts.mapChart('bubble-container', this.mapBubblesOptions)
    },
    components: {
        Modal,
        TasksCards,
        VueSimpleSuggest,
        'v-draggable-treeview': VuetifyDraggableTreeview,
        MaximizeAndMinimize
    },
    computed: {
        ...mapState({
            me: state => state['auth'].me,
            restockingData: state => state[model].data,
            restockingDataLoading: state => state[model].dataLoading,
            filters: state => state[model].filters,

            treePage: state => state['nodes'].page,
            treeAncestors: state => state['nodes'].ancestors,
            channelsData: state => state['branches'].channels,
            branchesData: state => state['branches'].nameIds,
            _statesData: state => state['places'].states,
            _citiesData: state => state['places'].cities,
            readingCities: state => state['places'].readingCities,
            readingStates: state => state['places'].readingStates,
            totalTasks: state => state['tasks'].totalTasks
        }),
        screenVisible() {
            if (this.me)
                return (
                    this.me.permissions.indexOf('restocking.view_charts') > -1
                )
            return false
        },

        filterLiked() {
            return this.filters.filter(x => x.liked)
        },
        filterUnLiked() {
            return this.filters.filter(x => !x.liked)
        },
        treeData() {
            return [{ name: 'Todos os itens', id: null }] //this.treePage.results
        },
        channelNames() {
            let channels = {}
            this.channelsData.forEach(item => {
                channels[item.id] = item.name
            })
            return channels
        }
    },
    data() {
        return {
            selectedHistoryFilter: null,
            selectedHistoryFilterName: null,
            selectedHistoryFilterNode: null,
            selectedHistoryFilterNodeName: null,
            selectedHistoryFilterFields: {
                product: null,
                cluster: null,
                channel: null,
                region: null,
                state: null,
                city: null,
                dc: null
            },
            filterDirty: false,
            filterModal: false,

            productModel: '',

            treeModal: false,

            branchScatterOptions: {
                chart: {
                    type: 'scatter',
                    zoomType: 'xy'
                },
                title: {
                    text: 'Dispersão de Lojas por TC e Faturamento'
                },
                xAxis: {
                    title: {
                        enabled: true,
                        text: 'Tempo de Cobertura'
                    },
                    startOnTick: true,
                    endOnTick: true,
                    showLastLabel: true
                },
                yAxis: {
                    title: {
                        text: 'Faturamento'
                    }
                },
                plotOptions: {
                    scatter: {
                        marker: {
                            radius: 5,
                            states: {
                                hover: {
                                    enabled: true,
                                    lineColor: 'rgb(100,100,100)'
                                }
                            }
                        },
                        states: {
                            hover: {
                                marker: {
                                    enabled: false
                                }
                            }
                        },
                        tooltip: {
                            headerFormat: '',
                            pointFormat:
                                '<b>{point.branch}</b><br>{point.x} dias, R$ {point.y}'
                        }
                    }
                },
                series: [
                    {
                        name: 'Lojas',
                        color: 'rgba(119, 152, 191, .5)',
                        data: []
                    }
                ]
            },
            mapBubblesOptions: {
                chart: {
                    map: 'countries/br/br-all'
                },
                title: {
                    text: 'Dispersão de Lojas por Localização e TC'
                },
                mapNavigation: {
                    enabled: true
                },
                tooltip: {
                    headerFormat: '',
                    pointFormat:
                        '<b>{point.name}</b><br>TC: {point.marker.radius}'
                },
                colorAxis: {
                    min: 0,
                    max: 20
                },
                plotOptions: {
                    mappoint: {
                        cluster: {
                            enabled: true,
                            allowOverlap: false,
                            animation: {
                                duration: 450
                            },
                            layoutAlgorithm: {
                                type: 'grid',
                                gridSize: 70
                            },
                            zones: [
                                {
                                    from: 0,
                                    to: 100,
                                    marker: {
                                        radius: 20
                                    }
                                }
                            ]
                        }
                    }
                },
                series: [
                    {
                        name: 'Basemap',
                        borderColor: '#A0A0A0',
                        nullColor: 'rgba(177, 244, 177, 0.5)',
                        showInLegend: false
                    },
                    {
                        type: 'mappoint',
                        enableMouseTracking: true,
                        colorKey: 'clusterPointsAmount',
                        name: 'Filiais',
                        data: []
                    }
                ]
            },
            coverageBarsOptions: {
                chart: {
                    type: 'bar'
                },
                title: {
                    text: 'Tempo de Cobertura por Árvore de Sortimento'
                },
                xAxis: {
                    type: 'category'
                },
                yAxis: {
                    min: 0,
                    title: {
                        text: 'Tempo de Cobertura'
                    }
                },
                series: [
                    {
                        name: 'Árvore de Sortimento',
                        data: []
                    }
                ]
            },
            supplierScatterOptions: {
                chart: {
                    type: 'scatter',
                    zoomType: 'xy'
                },
                title: {
                    text: 'Dispersão de Fornecedores por TC e Faturamento'
                },
                xAxis: {
                    title: {
                        enabled: true,
                        text: 'Tempo de Cobertura'
                    },
                    startOnTick: true,
                    endOnTick: true,
                    showLastLabel: true
                },
                yAxis: {
                    title: {
                        text: 'Faturamento'
                    }
                },
                plotOptions: {
                    scatter: {
                        marker: {
                            radius: 5,
                            states: {
                                hover: {
                                    enabled: true,
                                    lineColor: 'rgb(100,100,100)'
                                }
                            }
                        },
                        states: {
                            hover: {
                                marker: {
                                    enabled: false
                                }
                            }
                        },
                        tooltip: {
                            headerFormat: '',
                            pointFormat:
                                '<b>{point.supplier}</b><br>{point.x} dias, R$ {point.y}'
                        }
                    }
                },
                series: [
                    {
                        name: 'Fornecedores',
                        color: 'rgba(119, 152, 191, .5)',
                        data: []
                    }
                ]
            }
        }
    },
    methods: {
        ...mapActions('auth', { getMe: 'me' }),
        ...mapActions(model, {
            readEntities: 'read',
            createFilter: 'createFilter',
            readFilters: 'readFilters',
            updateFilter: 'updateFilter',
            deleteFilter: 'deleteFilter',
            likeFilter: 'likeFilter',
            unlikeFilter: 'unlikeFilter',
            updateLastSeenFilter: 'updateLastSeenFilter'
        }),
        ...mapActions('nodes', {
            readTreeNodes: 'read',
            readTreeAncestors: 'readAncestors'
        }),
        ...mapActions('branches', {
            readBranchChannels: 'readChannels',
            readBranchNameIds: 'readNameIds'
        }),
        ...mapActions('places', {
            readPlaces: 'read'
        }),
        ...mapActions('tasks', {
            readTotalTasks: 'readTotalTasks'
        }),

        async selectHistoryFilter(filter) {
            this.selectedHistoryFilterName = filter.name
            // generate hierarchical node name & return the node object
            this.nameTreeNode(filter.node)
            // set editable fields
            Object.keys(this.selectedHistoryFilterFields).forEach(key => {
                this.selectedHistoryFilterFields[key] = filter[key]
            })
            if (!filter.channel) {
                filter.channel = 'A'
                this.selectedHistoryFilterFields.channel = 'A'
            }

            this.filterDirty = false
            this.selectedHistoryFilter = filter
            this.productUpdate()
            await this.applyFilter()
        },

        unlike(filterId) {
            if (!this.unlikeFilter(filterId)) {
                this.filters.map(filter => {
                    if (filter.id == filterId) {
                        filter.liked = false
                    }
                })
            }
        },
        like(filterId) {
            if (!this.likeFilter(filterId)) {
                this.filters.map(filter => {
                    if (filter.id == filterId) {
                        filter.liked = true
                    }
                })
            }
        },

        preProcessFilter() {
            if (!this.selectedHistoryFilter) {
                this.filterDirty = false
                return
            }

            this.filterDirty = false
            Object.keys(this.selectedHistoryFilterFields).forEach(key => {
                this.filterDirty =
                    this.filterDirty ||
                    this.selectedHistoryFilter[key] !==
                        this.selectedHistoryFilterFields[key]
            })
            if (this.selectedHistoryFilterNode)
                this.filterDirty =
                    this.filterDirty ||
                    this.selectedHistoryFilter['node'] !==
                        this.selectedHistoryFilterNode['id']
        },

        posProcessFilter() {
            let hasFilter = this.filters.filter(
                item => item.name == this.selectedHistoryFilterName
            )
            if (hasFilter && hasFilter.length > 0) {
                this.selectedHistoryFilter = hasFilter[0]
                this.filterDirty = false
            }
        },

        changeName() {
            if (this.filterDirty) {
                let filterName = ''
                if (
                    this.selectedHistoryFilterNode != null &&
                    this.selectedHistoryFilterNodeName != null
                ) {
                    filterName += this.selectedHistoryFilterNodeName
                }
                if (
                    this.productModel &&
                    this.selectedHistoryFilterFields['product']
                ) {
                    if (filterName.length > 0) filterName += ' / '
                    filterName += this.productModel
                }
                if (
                    this.selectedHistoryFilterFields['channel'] &&
                    this.selectedHistoryFilterFields['channel'] !== 'A'
                ) {
                    if (filterName.length > 0) filterName += ' / '
                    filterName += this.channelNames[
                        this.selectedHistoryFilterFields['channel']
                    ]
                }
                Object.keys(this.selectedHistoryFilterFields).forEach(key => {
                    if (
                        this.selectedHistoryFilterFields[key] &&
                        key != 'product' &&
                        key != 'channel'
                    ) {
                        if (filterName.length > 0) filterName += ' / '
                        filterName += this.selectedHistoryFilterFields[key]
                    }
                })
                this.selectedHistoryFilterName = filterName
            } else if (this.selectedHistoryFilter) {
                this.selectedHistoryFilterName = this.selectedHistoryFilter[
                    'name'
                ]
            }
        },

        filterModalOpen(state) {
            if (!state) {
                this.filterEditable = false
            }
            this.filterModal = state
        },

        treeModalOpen(state) {
            this.treeModal = state
        },

        async applyFilter() {
            if (this.filterDirty) {
                let error = await this.createFilter({
                    name: this.selectedHistoryFilterName,
                    node: this.selectedHistoryFilterNode.id,
                    ...this.selectedHistoryFilterFields
                })
                if (error) {
                    this.$notify({
                        message: 'Erro ao criar filtro.',
                        icon: 'add_alert',
                        horizontalAlign: 'right',
                        verticalAlign: 'bottom',
                        type: 'danger'
                    })
                } else {
                    // reload selected to saved filter
                    this.selectedHistoryFilter.name = this.selectedHistoryFilterName
                    this.selectedHistoryFilter.node = this.selectedHistoryFilterNode.id

                    // set editable fields
                    Object.keys(this.selectedHistoryFilterFields).forEach(
                        key => {
                            this.selectedHistoryFilter[
                                key
                            ] = this.selectedHistoryFilterFields[key]
                        }
                    )
                    this.filterDirty = false
                }
            } else if (this.selectedHistoryFilter.id != null) {
                let error = await this.updateLastSeenFilter(
                    this.selectedHistoryFilter.id
                )
                if (error) {
                    this.$notify({
                        message: 'Erro ao atualizar filtro.',
                        icon: 'add_alert',
                        horizontalAlign: 'right',
                        verticalAlign: 'bottom',
                        type: 'danger'
                    })
                }
            }

            let apply_filter = { ...this.selectedHistoryFilter }
            apply_filter.channel =
                apply_filter.channel === 'A' ? null : apply_filter.channel

            // read route data
            await this.readEntities(apply_filter)

            if (this.restockingData.branch_scatter)
                this.branchScatterOptions.series[0].data = this.restockingData.branch_scatter
            if (this.restockingData.supplier_scatter)
                this.supplierScatterOptions.series[0].data = this.restockingData.supplier_scatter
            if (this.restockingData.coverage_bars)
                this.coverageBarsOptions.series[0].data = this.restockingData.coverage_bars

            if (this.restockingData.branch_bubble) {
                this.mapBubblesOptions.series[1].data = []
                this.restockingData.branch_bubble.forEach(branchData => {
                    this.mapBubblesOptions.series[1].data.push({
                        name: branchData.branch,
                        lat: branchData.latitude,
                        lon: branchData.longitude,
                        marker: {
                            radius: branchData.coverage
                        }
                    })
                })
            }
        },

        async nameTreeNode(idNode) {
            await this.readTreeAncestors({ id: idNode })
            if (idNode && this.treeAncestors.length > 0) {
                this.selectedHistoryFilterNodeName = ''
                this.treeAncestors.forEach((ancestor, index) => {
                    if (index > 0) this.selectedHistoryFilterNodeName += ' > '
                    this.selectedHistoryFilterNodeName += ancestor.name
                })
                this.selectedHistoryFilterNode = this.treeAncestors[
                    this.treeAncestors.length - 1
                ]
            } else {
                this.selectedHistoryFilterNode = new Node()
                this.selectedHistoryFilterNodeName = 'Todos os itens'
            }
        },
        readTreeChild(item) {
            return this.readTreeNodes({ item })
        },
        async selectTreeChild(item) {
            this.nameTreeNode(item.id)
            this.treeModal = false
        },

        async productsList() {
            let products = await ProductService.read({
                q: this.productModel
            })
                .then(res => res.data)
                .then(json => json.results)
            products = products.map(item => {
                item.name = item.external_id + ' - ' + item.name
                return item
            })
            return products
        },
        async productUpdate() {
            if (!this.selectedHistoryFilter.product) {
                this.productModel = ''
                return
            }
            let product = await ProductService.read(
                this.selectedHistoryFilter.product
            ).then(res => res.data)
            this.productModel =
                product.external_id && product.name
                    ? product.external_id + ' - ' + product.name
                    : 'Erro!'
        },
        productSelected(selectedItem) {
            this.productModel = selectedItem.name
            this.selectedHistoryFilterFields['product'] = selectedItem.id
        },

        formatNumber: (number, type, shorten) =>
            Utils.formatNumber(number, type, shorten)
    },
    watch: {
        selectedHistoryFilterNode: {
            handler: function(val) {
                this.preProcessFilter()
                this.changeName()
                this.posProcessFilter()
            },
            deep: true
        },
        selectedHistoryFilterFields: {
            handler: function(val) {
                this.preProcessFilter()
                this.changeName()
                this.posProcessFilter()
            },
            deep: true
        },
        productModel: {
            handler: function(val) {
                if (val.length < 6) {
                    this.productModel = ''
                    this.selectedHistoryFilterFields['product'] = null
                }
                this.preProcessFilter()
                this.changeName()
                this.posProcessFilter()
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.md-toolbar {
    background-color: #12578f !important;
    position: fixed !important;
    top: 50px;
    left: 280px;
    right: 20px;
    width: auto;
}
.sidebar-mini .md-toolbar {
    margin-left: 20px;
    right: 20px;
    left: 80px;
}
</style>
<!-- TODO isso devia ser scoped -->
<style lang="css">
.btn-star {
    border: none;
    background: none;
    cursor: pointer;
}
.md-input {
    width: 100%;
}
.md-table-head {
    text-align: center;
}
.md-table-head-label {
    font-weight: bold;
}

td.out-of-reference {
    background: #3c8db9;
    color: #fff;
}
#assortmentTable > tbody > tr:last-child {
    font-weight: bold;
}
.no-hover:hover {
    background-color: initial;
}
.modal-container {
    max-height: 600px;
    max-width: 800px;
    overflow: auto;
}
.cell-drill-down:hover {
    cursor: pointer;
    background: #eee;
}
.md-table-cell {
    max-width: 100px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    border: 1px solid #eee;
}
.topper-chart {
    min-height: 500px;
}

:root {
    --color-1: #3c8db9; /* Estoque */
    --color-2: #49b29d; /* Não estoque */
    --color-3: #3c8db9; /* Ativo */
    --color-4: #6bf3d8; /* Inativo */
    --color-5: #22526d; /* Novo */
    --color-6: #ff0000; /* Obsoleto */
    --color-7: #213169; /* Em descotinuacao */
    --color-8: #111a3b; /* Descotinuado */
    --color-9: #49b29d; /* TC */
    --color-10: #6bf3d8; /* TC meta */
}
.item .n-0 {
    fill: var(--color-1);
}
.item .n-1 {
    fill: var(--color-2);
}
.item .n-2 {
    fill: var(--color-3);
}
.item .n-3 {
    fill: var(--color-4);
}
.item .n-4 {
    fill: var(--color-5);
}
.item .n-5 {
    fill: var(--color-6);
}
.item .n-6 {
    fill: var(--color-7);
}
.item .n-7 {
    fill: var(--color-8);
}

.item .highcharts-point.p-0-1 {
    fill: var(--color-1);
    opacity: 0.6;
}
.item .highcharts-point.p-0-2 {
    fill: var(--color-1);
    opacity: 0.6;
}
.item .highcharts-point.p-0-3 {
    fill: var(--color-1);
    opacity: 0.6;
}
.item .highcharts-point.p-0-4 {
    fill: var(--color-1);
    opacity: 0.6;
}
.item .highcharts-point.p-0-5 {
    fill: var(--color-1);
    opacity: 0.6;
}
.item .highcharts-point.p-0-6 {
    fill: var(--color-1);
    opacity: 0.6;
}
.item .highcharts-point.p-0-7 {
    fill: var(--color-1);
    opacity: 0.6;
}

.item .highcharts-point.p-0-1:hover {
    opacity: 1;
}
.item .highcharts-point.p-0-2:hover {
    opacity: 1;
}
.item .highcharts-point.p-0-3:hover {
    opacity: 1;
}
.item .highcharts-point.p-0-4:hover {
    opacity: 1;
}
.item .highcharts-point.p-0-5:hover {
    opacity: 1;
}
.item .highcharts-point.p-0-6:hover {
    opacity: 1;
}
.item .highcharts-point.p-0-7:hover {
    opacity: 1;
}

.item .highcharts-point.p-1-1 {
    fill: var(--color-2);
    opacity: 0.6;
}
.item .highcharts-point.p-1-2 {
    fill: var(--color-2);
    opacity: 0.6;
}
.item .highcharts-point.p-1-3 {
    fill: var(--color-2);
    opacity: 0.6;
}
.item .highcharts-point.p-1-4 {
    fill: var(--color-2);
    opacity: 0.6;
}
.item .highcharts-point.p-1-5 {
    fill: var(--color-2);
    opacity: 0.6;
}
.item .highcharts-point.p-1-6 {
    fill: var(--color-2);
    opacity: 0.6;
}
.item .highcharts-point.p-1-7 {
    fill: var(--color-2);
    opacity: 0.6;
}

.item .highcharts-point.p-1-1:hover {
    opacity: 1;
}
.item .highcharts-point.p-1-2:hover {
    opacity: 1;
}
.item .highcharts-point.p-1-3:hover {
    opacity: 1;
}
.item .highcharts-point.p-1-4:hover {
    opacity: 1;
}
.item .highcharts-point.p-1-5:hover {
    opacity: 1;
}
.item .highcharts-point.p-1-6:hover {
    opacity: 1;
}
.item .highcharts-point.p-1-7:hover {
    opacity: 1;
}

.stock .highcharts-color-0 .highcharts-point {
    fill: var(--color-1);
    stroke: var(--color-1);
}
.stock .highcharts-color-1 .highcharts-point {
    fill: var(--color-5);
    stroke: var(--color-5);
}
.stock .highcharts-color-2 .highcharts-point {
    fill: var(--color-7);
    stroke: var(--color-7);
}
.stock .highcharts-color-3 .highcharts-point {
    fill: var(--color-8);
    stroke: var(--color-8);
}
.stock .highcharts-color-4 .highcharts-point {
    fill: var(--color-6);
    stroke: var(--color-6);
}
.stock .highcharts-color-5 .highcharts-point {
    fill: var(--color-9);
    stroke: var(--color-9);
}
.stock .highcharts-color-5 .highcharts-graph {
    stroke: var(--color-9);
}
.stock .highcharts-color-6 .highcharts-point {
    fill: var(--color-10);
    stroke: var(--color-10);
}
.stock .highcharts-color-6 .highcharts-graph {
    stroke: var(--color-10);
}

.item .highcharts-point.p-4-5 {
    fill: var(--color-6);
    opacity: 0.6;
}
.item .highcharts-point.p-5-6 {
    fill: var(--color-6);
    opacity: 0.6;
}

.item .highcharts-point.p-5-7 {
    fill: var(--color-6);
    opacity: 0.6;
}
.item .highcharts-point.p-4-5:hover {
    opacity: 1;
}
.item .highcharts-point.p-5-6:hover {
    opacity: 1;
}
.item .highcharts-point.p-5-7:hover {
    opacity: 1;
}
</style>
